import { atomWithStorage, createJSONStorage } from "jotai/utils";
import type { AppliedCouponSessionPayload } from "@/types/coupon";
import { CheckoutPayload } from "@/hooks/booking-checkout/booking.checkout.helpers";
import { TourActBookingKeyPayload } from "@/components/main-services/tour-act/checkout/tour.checkout.type";

const noopStorage = {
  getItem: () => null,
  setItem: () => { },
  removeItem: () => { },
};

const tourActCheckoutStorage = createJSONStorage<CheckoutPayload | null>(
  () => (typeof window === "undefined" ? noopStorage : window.sessionStorage),
);

export const tourActCheckoutPayloadAtom =
  atomWithStorage<CheckoutPayload | null>(
    "tovtrip_tour_act_checkout_payload",
    null,
    tourActCheckoutStorage,
    { getOnInit: true },
  );

const tourActBookingKeyStorage =
  createJSONStorage<TourActBookingKeyPayload | null>(() =>
    typeof window === "undefined" ? noopStorage : window.sessionStorage,
  );

const tourActAppliedCouponStorage =
  createJSONStorage<AppliedCouponSessionPayload | null>(() =>
    typeof window === "undefined" ? noopStorage : window.sessionStorage,
  );

export const tourActBookingKeyAtom =
  atomWithStorage<TourActBookingKeyPayload | null>(
    "tovtrip_tour_act_booking_key",
    null,
    tourActBookingKeyStorage,
    { getOnInit: true },
  );

export const tourActAppliedCouponAtom =
  atomWithStorage<AppliedCouponSessionPayload | null>(
    "tovtrip_tour_act_applied_coupon",
    null,
    tourActAppliedCouponStorage,
    { getOnInit: true },
  );

export const tourActSelectionAtom =
  atomWithStorage<any | null>(
    "tovtrip_tour_act_selection",
    null,
    tourActCheckoutStorage,
    { getOnInit: true },
  );